var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#593C35;}\r\n\t.st1{fill:#2C353A;}\r\n\t.st2{fill:#43525B;}\r\n\t.st3{fill:#CACBCD;}\r\n\t.st4{fill:#E4E5E7;}\r\n\t.st5{fill:#49AAD0;}\r\n\t.st6{fill:#62C0DB;}\r\n\t.st7{fill:#7F5650;}\r\n\t.st8{fill:#8E6662;}\r\n\t.st9{fill:#F5B94C;}\r\n\t.st10{fill:#F9D161;}\r\n\t.st11{fill:#B13B27;}\r\n\t.st12{fill:#DD4334;}\r\n\t.st13{fill:#E7B541;}\r\n\t.st14{fill:#2C6B83;}\r\n\t.st15{fill:#337DA1;}\r\n\t.st16{fill:#E47971;}\r\n\t.st17{fill:#E99B97;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "60.8,60 55,70 50.8,70 56.7,60  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    className: "st1",
    width: 50,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 20,
    className: "st2",
    width: 47.5,
    height: 37.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 23.3,
    className: "st3",
    width: 50,
    height: 33.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.7,
    y: 23.3,
    className: "st4",
    width: 48.3,
    height: 31.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.2,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.2,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.2,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.2,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 20,
    className: "st4",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.2,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.2,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.2,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.2,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 56.7,
    className: "st3",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 26.7,
    className: "st5",
    width: 10,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 26.7,
    className: "st6",
    width: 9.2,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 26.7,
    className: "st7",
    width: 10,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 26.7,
    className: "st8",
    width: 9.2,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 26.7,
    className: "st9",
    width: 10,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.8,
    y: 26.7,
    className: "st10",
    width: 9.2,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 46.7,
    className: "st11",
    width: 10,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 46.7,
    className: "st12",
    width: 9.2,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2,
    y: 46.7,
    className: "st13",
    width: 10,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 46.7,
    className: "st14",
    width: 10,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.8,
    y: 46.7,
    className: "st15",
    width: 9.2,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 36.7,
    className: "st16",
    width: 25,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 36.7,
    className: "st17",
    width: 24.2,
    height: 5.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "55.7,61.7 50.8,70 55,70 59.9,61.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "69.2,60 75,70 79.2,70 73.3,60  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "74.3,61.7 79.2,70 75,70 70.1,61.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 46.7,
    className: "st10",
    width: 9.2,
    height: 5.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryboard);
export default __webpack_public_path__ + "static/media/Storyboard.91f5a724f520ea387a1022737da1c9a9.svg";
export { ForwardRef as ReactComponent };